import * as React from 'react';
import { Loader, Alert } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const UnlinkView = ({ viewType , unlinkedItemId , unlinkType  })=>{
    const { getLabel , getFormattedLabel  } = useIntl();
    const titleLabel = viewType === 'success' ? `account.${unlinkType}.success.title` : `account.${unlinkType}.title`;
    if (!viewType) {
        return /*#__PURE__*/ React.createElement(Loader, null);
    } else {
        return /*#__PURE__*/ React.createElement("div", {
            className: "unlink-view",
            "data-t": "unlink-view"
        }, /*#__PURE__*/ React.createElement(Heading, {
            variant: "small",
            component: "h1",
            className: "unlink-view__title"
        }, getLabel(titleLabel)), viewType === 'success' && /*#__PURE__*/ React.createElement("p", null, getFormattedLabel(`account.${unlinkType}.success.message`, {
            labelData: {
                unlinkedItemId
            },
            parseLink: true
        })), viewType === 'failed' && /*#__PURE__*/ React.createElement(Alert, {
            type: "error",
            icon: "alert-circle",
            title: getLabel(`account.${unlinkType}.error.title`),
            message: getFormattedLabel(`account.${unlinkType}.error.message`, {
                labelData: {
                    unlinkedItemId
                },
                parseLink: true
            })
        }));
    }
};
var UnlinkView$1 = UnlinkView;

export { UnlinkView$1 as default };
//# sourceMappingURL=UnlinkView.js.map
